import type { FunctionComponent } from 'react';
import { getLifeSVGEventIcon } from '../../icons/iconUtils';

export const MAX_EVENTS_SHOW_IN_POPOVER = 3;

interface IProps {
    amount: number;
    title: string;
    description: string;
    isClickPopover: boolean;
    topicKey: string;
    onOpenModalClick: () => void;
}

export const CashEventCard: FunctionComponent<IProps> = ({ amount, title, description, isClickPopover, topicKey, onOpenModalClick }) => (
    <div
        onClick={onOpenModalClick}
        className={`cash-event-card ${isClickPopover ? 'cash-event-card--click-popover' : ''}
         ${isClickPopover && amount >= MAX_EVENTS_SHOW_IN_POPOVER ? 'cash-event-card--scrollable' : ''}`}
    >
        <div className="cash-event-card__icon">{getLifeSVGEventIcon(topicKey)}</div>
        <div className="cash-event-card__wrapper">
            <div className="cash-event-card__content">
                <div className="cash-event-card__title">{title}</div>
                <div className="cash-event-card__description">{description}</div>
            </div>
        </div>
        <div className="cash-event-card__trailing-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.83398 14.7096L6.95898 13.8346L10.7923 10.0013L6.95898 6.16797L7.83398 5.29297L12.5423 10.0013L7.83398 14.7096Z" fill="#818288" />
            </svg>
        </div>
    </div>
);
